var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(-533 -395)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 20,
    height: 20,
    transform: "translate(533 395)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lead-Detail_Activity_V3",
    transform: "translate(539.618 398.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lead-Detail-Page-_Basic-Details-_v3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title-Header",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-information"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "designation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_tie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1.719,10.147a.712.712,0,0,1-.181-.7l.636-2.875a.66.66,0,0,1,.684-.455H3.906a.661.661,0,0,1,.684.455L5.226,9.48a.684.684,0,0,1-.181.683l-1.16,1.153a.712.712,0,0,1-1.007-.008Zm.6-5.452a1.37,1.37,0,0,0-1.368.971l-.9,3.824a1.394,1.394,0,0,0,.362,1.382l1.959,1.952a1.424,1.424,0,0,0,2.013,0L6.348,10.86a1.425,1.425,0,0,0,.362-1.4l-.9-3.794A1.371,1.371,0,0,0,4.444,4.7Zm1.387-1.85H3.056a.712.712,0,1,1,0-1.423h.652a.712.712,0,0,1,0,1.423ZM5.952,1.657A1.423,1.423,0,0,0,4.548,0H2.216a1.423,1.423,0,0,0-1.4,1.657L1.05,3.08a1.423,1.423,0,0,0,1.4,1.189H4.311a1.423,1.423,0,0,0,1.4-1.189Z",
    transform: "translate(0 0)",
    fill: "#bcbec0",
    fillRule: "evenodd"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.73f2cc621ed3a535a6443ad21f8adbe9.svg";
export { ForwardRef as ReactComponent };